import React, { useState, useEffect } from "react";
import "./CardSelector.css";

const images = [
  {
    imgURL: "images/home/cctv.png",
    imgAlt: "img-1",
  },
  {
    imgURL: "images/home/video.png",
    imgAlt: "img-2",
  },
  {
    imgURL: "images/home/epabx.png",
    imgAlt: "img-3",
  },
  {
    imgURL: "images/home/boom.png",
    imgAlt: "img-4",
  },
  {
    imgURL: "images/home/network.png",
    imgAlt: "img-5",
  },
  {
    imgURL: "images/home/access.png",
    imgAlt: "img-6",
  },
];

const CardSelector = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Preload images
  useEffect(() => {
    images.forEach((image) => {
      const img = new Image();
      img.src = image.imgURL;
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-slider">
      <button onClick={prevSlide} className="slider-button left">
        ◀
      </button>
      <img
        src={images[currentIndex].imgURL}
        alt={images[currentIndex].imgAlt}
        className="slider-image"
        loading="lazy"
      />
      <button onClick={nextSlide} className="slider-button right">
        ▶
      </button>
      <div className="dots-container">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default CardSelector;
